import { render, staticRenderFns } from "./UrlShortenerAdmin.vue?vue&type=template&id=5b609d80&"
import script from "./UrlShortenerAdmin.vue?vue&type=script&lang=js&"
export * from "./UrlShortenerAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports